import { useContext } from 'react';
import { GlobalContext } from '@/shared/GlobalContext/GlobalContext';
import { getUserType } from '@/modules/userUtils';
import { isAxiosAuthorized } from '@/modules/api/axiosInterceptors';

export default function useCurrentUser() {
  const isAuthorized = isAxiosAuthorized();
  const context = useContext(GlobalContext);

  if (!isAuthorized) {
    return {
      userId: null,
      userType: null,
      user: null,
    };
  }

  const user = context.state.user?.teacher || context.state.user?.student;

  return {
    userId: user?.id || null,
    userType: getUserType(context.state.user),
    user,
  };
}
